export const RADIUS = 20;

export const drawNetwork = (context, width, height, nodes, links, selectedNode) => {
  context.clearRect(0, 0, width, height);

  // Draw the links
  links.forEach((link) => {
    context.beginPath();
    context.moveTo(link.source.x, link.source.y);
    context.lineTo(link.target.x, link.target.y);
    context.stroke();
  });

  // Draw the nodes
  nodes.forEach((node) => {
    if (!node.x || !node.y) {
      return;
    }
    context.beginPath();
    context.moveTo(node.x + RADIUS, node.y);
    context.arc(node.x, node.y, RADIUS, 0, 2 * Math.PI);

    console.log(selectedNode);
    //console.log(node.metadata.id);
    
    // Highlight the selected node
    if (selectedNode && node.id === selectedNode.id) {
      context.fillStyle = '#000000'; // Red color for selected node
      context.strokeStyle = '#000000'; // Black border for selected node
      context.lineWidth = 0.5;
      context.fill();
      context.stroke();
    } else {
      context.fillStyle = '#ffffff';
      context.strokeStyle = '#000000';
      context.lineWidth = 0.5;
      context.fill();
      context.stroke();
    }
  });
};